import CartItems from './cart-items/CartItems';
import Checkout from './Checkout';
import DiscountLabel from './DiscountLabel';
import OptionsContextMenuAndCommentButtons from './CartHeader/CartHeader';
import { useMemo, useState } from 'react';

const Cart = () => {
  const [openDiscountDialog, setOpenDiscountDialog] = useState(false);

  const cartItems = useMemo(() => {
    return <CartItems />;
  }, []);

  return (
    <>
      <OptionsContextMenuAndCommentButtons
        openDiscountDialog={openDiscountDialog}
        setOpenDiscountDialog={setOpenDiscountDialog}
      />
      <div className="overflow-auto h-full">
        <DiscountLabel setOpenDiscountDialog={setOpenDiscountDialog} />
        {cartItems}
      </div>
      <Checkout />
    </>
  );
};

export default Cart;
